import React from "react";
import classes from "./navbar.module.css";

const Navbar = () => {
  return (
    <header className={classes.header}>
      <div className={classes.headerContent}>
        <div className={classes.logoContainer}>
          <div className={classes.logoIcon}>
            <svg viewBox="0 0 50 50" className={classes.catLogo}>
              <ellipse
                cx="25"
                cy="30"
                rx="12"
                ry="15"
                fill="#FFD9E8"
                stroke="#FF9DC4"
                strokeWidth="1.5"
              />
              <ellipse
                cx="18"
                cy="15"
                rx="4"
                ry="10"
                fill="#FFD9E8"
                stroke="#FF9DC4"
                strokeWidth="1.5"
              />
              <ellipse
                cx="32"
                cy="15"
                rx="4"
                ry="10"
                fill="#FFD9E8"
                stroke="#FF9DC4"
                strokeWidth="1.5"
              />
              <ellipse cx="21" cy="28" rx="1.5" ry="1.5" fill="#FF6B9E" />
              <ellipse cx="29" cy="28" rx="1.5" ry="1.5" fill="#FF6B9E" />
              <ellipse cx="25" cy="31" rx="2" ry="1" fill="#FF9DC4" />
            </svg>
          </div>
          <h1 className={classes.logoText}>My Cat's Name</h1>
        </div>
        <nav className={classes.nav}>
          <ul>
            <li>
              <a href="#" className={classes.active}>
                Home
              </a>
            </li>
            {/* <li>
              <a href="#">Name Categories</a>
            </li>
            <li>
              <a href="#">Popular Names</a>
            </li>
            <li>
              <a href="#">About</a>
            </li> */}
          </ul>
        </nav>
      </div>
      <div className={classes.headerWave}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 100"
          preserveAspectRatio="none"
        >
          <path
            fill="#FFF5F9"
            d="M0,0 C320,80 480,60 720,50 C960,40 1120,60 1440,0 L1440,100 L0,100 Z"
          ></path>
        </svg>
      </div>
    </header>
  );
};

export default Navbar;
